import { render, staticRenderFns } from "./returnRecordInitHis.vue?vue&type=template&id=7c8ff3f8&scoped=true"
import script from "./returnRecordInitHis.vue?vue&type=script&lang=js"
export * from "./returnRecordInitHis.vue?vue&type=script&lang=js"
import style0 from "./returnRecordInitHis.vue?vue&type=style&index=0&id=7c8ff3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8ff3f8",
  null
  
)

export default component.exports